"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
// General scroll to element function
exports.Home = ({ workspace }) => {
    return (react_1.default.createElement(react_2.OsmosysSmallContainer, null,
        react_1.default.createElement("h1", { className: "text-center m-0" }, workspace.name)));
};
//# sourceMappingURL=Home.js.map